<!--
@component
Footer.Link

A link component for the footer, styled consistently with the footer design.

@prop href - The URL the link points to.
@prop css - Custom CSS styles to be applied to the link.
@prop use - Actions to be applied to the link element.

@example
<Footer.Link href="/about" use={[myAction]}>About Us</Footer.Link>
-->



<script lang="ts">
  import type { FooterLinkProps } from '../footer.types';
  import { css } from '@agapi/ui/panda/css';
  import { footerStyles } from '../footer.styles';
  import { useActions } from '../../../utils/useAction';

  /** Props for the Footer.Link component. */
  const { children, href, css: cssProp = {}, use }: FooterLinkProps = $props();

  /** Classes for the footer link. */
  const classes = footerStyles.raw({});
</script>

<a {href} use:useActions={use ?? []} class={css(classes.link, cssProp)}>
  {@render children?.()}
</a>